import { Link } from 'react-router-dom';
import { Paintbrush } from 'lucide-react';
import { cn } from '@/lib/utils';

interface WordmarkProps {
  /** Link target; without it the wordmark is a plain, non-interactive mark. */
  to?: string;
  className?: string;
}

/**
 * The DesignDeck wordmark: a 32 px primary square with the paintbrush and
 * the name in the display face. Same markup as the Creator header's logo,
 * shared by the admin shell and the auth pages.
 */
export function Wordmark({ to, className }: WordmarkProps) {
  const content = (
    <>
      <span className="flex h-8 w-8 items-center justify-center rounded-control bg-primary">
        <Paintbrush className="h-5 w-5 text-primary-fg" aria-hidden="true" />
      </span>
      <span className="font-display text-xl font-bold tracking-[-0.01em] text-ink">
        DesignDeck
      </span>
    </>
  );
  const classes = cn('inline-flex items-center gap-2', className);

  if (to) {
    return (
      <Link to={to} className={classes}>
        {content}
      </Link>
    );
  }
  return <span className={classes}>{content}</span>;
}
